module.exports = __webpack_public_path__ + "img/menu32.4ef13b51.png";